<div class="quickview">
    <button *ngIf="!loading" class="quickview__close" type="button" appClick (click)="modalRef.hide()">
        <app-icon name="cross-20" size="20"></app-icon>
    </button>

    <h4 class="text-center"><img height="40" src="../../../../../assets/images/custom/Stripe.png">
    </h4>
    <br>
    <form>
        <div id="card-element"></div>
        <p id="card-error"></p>
        <br>
        <button id="payButton" class="btn btn-primary btn-primary-dark btn-md btn-block" [ngClass]="{'btn-loading': loading}"
        [disabled]="loading || btnDisabled"
            (click)="pay()">
            Paga
        </button>

    </form>

</div>